// extracted by mini-css-extract-plugin
export default {"inputStyles":"DeviceManager_inputStyles__wachl","portLabel":"DeviceManager_portLabel__DcP3C"};